/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamQuestionScopedRequest } from './oralExamQuestionScopedRequest';

export type SignalOralExamStudentDoneBody = OralExamQuestionScopedRequest | null;
